var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowChatroom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "7px",
    viewBox: "0 0 14 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowChatroom Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.68581485,3.99966365 L9.40303423,10.2933328 C9.653902,10.5688891 10.0603479,10.5688891 10.3118492,10.2933328 C10.5627169,10.0177766 10.5627169,9.57020123 10.3118492,9.29464501 L5.0481134,3.50034881 L10.3112157,-2.2939474 C10.5620834,-2.56950362 10.5620834,-3.017079 10.3112157,-3.29333284 C10.0603479,-3.56888905 9.6532685,-3.56888905 9.40240073,-3.29333284 L3.68518135,3.00027821 C3.4381674,3.27298586 3.4381674,3.72759549 3.68581485,3.99966365 Z",
    id: "arrowChatroom-Copy",
    fill: "#535353",
    fillRule: "nonzero",
    transform: "translate(7.000000, 3.500000) rotate(-90.000000) translate(-7.000000, -3.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowChatroom);
export default __webpack_public_path__ + "static/media/arrowChatroom.a3a03a28b90f4dddbe303d4cdda20e20.svg";
export { ForwardRef as ReactComponent };